<script>
    export let impressumVisible = 'invisible';
</script>


<div class="offcanvas offcanvas-end fixed bottom-0 flex flex-col max-w-full bg-white {impressumVisible} bg-clip-padding shadow-sm outline-none transition duration-300 ease-in-out text-slate-700 top-0 right-0 border-none w-96" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
	<div class="offcanvas-header flex items-center justify-between p-4">
	  	<h5 class="offcanvas-title mb-0 leading-normal font-semibold" id="offcanvasRightLabel">Impressum</h5>
		<button on:click type="button" class="btn-close box-content w-4 h-4 p-2 -my-5 -mr-2 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline" data-bs-dismiss="offcanvas" aria-label="Close">X</button>
	</div>
	<div class="offcanvas-body flex-grow p-4 overflow-y-auto">
		<p>
			<span class="font-bold">FH Kärnten</span> <br />
			gemeinnützige Gesellschaft mbH<br />
			9524 Villach, Europastraße 4<br />
			Kärnten, Österreich<br />
		</p>

		<h3 class="mt-4 font-bold">Haftungsausschluss</h3>
		<p >
			Die FH Kärnten ist bemüht, sämtliche Inhalte auf der Website richtig zu gestalten und aktuell zu halten. Sämtliche Texte auf der Website der FH Kärnten wurden sorgfältig geprüft. Dessen ungeachtet kann keine Gewährleistung für die Richtigkeit, Vollständigkeit und Aktualität der Angaben gegeben werden. Eine Haftung der FH Kärnten wird daher ausgeschlossen. Die Links zu anderen Webseiten wurden sorgfältig ausgewählt. Da die FH Kärnten auf deren Inhalt keinen Einfluss hat, übernimmt die FH Kärnten dafür keine Verantwortung. Die FH Kärnten haftet darüber hinaus nicht für unautorisierte Bewerbung ihrer Angebote.
			<br /><br />
			<span class="font-bold">Urheberrecht, IPR</span><br />
			Das Layout der Website, die verwendeten Grafiken und Bilder sowie die Inhalte der Website sind urheberrechtlich geschützt. Die FH Kärnten behält sich sämtliche Rechte daran vor. Die Bildmarke (Logo) der FH Kärnten ist geschützt. Deren Verwendung ist ohne ausdrückliche Zustimmung nicht gestattet.
		</p>

		<h4 class="mt-4 font-bold">Datenschutzhinweise</h4>
		<p class="mt-4 ">
			<span class="font-bold">Verantwortliche:</span> <br />
			FH Kärnten – gemeinnützige Gesellschaft mbH<br />
			Europastraße 4<br />
			9524 Villach<br />
			datenschutz[at]fh-kaernten[dot]at<br />

			<span class="font-bold">Datenschutzbeauftragter:</span> <br />
			Mag. Markus Dörfler LL.M.<br />
			Höhne, In der Maur & Partner<br />
			Rechtsanwälte GmbH & Co KG<br />
			dsb[at]fh-kaernten[dot]at<br />
		</p>
	</div>
</div>
